<template>
  <div style="width: 100%">
    <v-card
      v-if="relatorio"
      flat
      class="pa-2"
    >
      <!-- Gráficos -->
      <v-row>
        <v-col cols="12">
          <app-title texto="PREFERÊNCIAS DE TRABALHO" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <bar-chart
            :categorias="barChart.categorias"
            :dados="barChart.dados"
            :fonte="`Fonte: Sistema Desenvolva, ${ano}`"
            :tooltip="tooltip"
            titulo="Comparativo das Respostas"
            descricao-eixo-y="Quantidade de Servidores"
            exibe-categorias
            font-size-eixo-x="12"
            :is-get-svg="isGetSvg"
            @svg="(value) => svg = value"
          />
        </v-col>
      </v-row>

      <!-- Resultados -->
      <v-row>
        <v-col cols="12">
          <app-title texto="RESULTADOS" />
        </v-col>
        <v-col cols="12">
          <tabela-resultado
            :relatorio="relatorio"
            :is-geral="isGeral"
          />
        </v-col>
      </v-row>

      <!-- Relatório PDF -->
      <v-row
        class="justify-end mb-1"
      >
        <v-tooltip
          max-width="400"
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="success"
              @click="getRelatorio()"
              v-on="on"
            >
              <v-icon>get_app</v-icon>
              BAIXAR PDF
            </v-btn>
          </template>
          <span>Clique para baixar o relatório dos dados em formato PDF.</span>
        </v-tooltip>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import BarChart from '@/components/chart/BarChart';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import TabelaResultado from './TabelaResultadoPreferencia';

export default {
  name: 'RelatorioPerfilPreferencia',

  components: {
    AppTitle,
    BarChart,
    TabelaResultado,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
    },
    ano: {
      type: String,
      default: '',
    },
    isGeral: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tooltip: {
        formatter() {
          return `
            <span style="padding:2px;color:${this.series.color}"><b>${this.point.name}</b></span>
            <table>
              <tr>
                <td style="padding:0">Quantidade de Servidores: </td>
                <td style="padding:2px;text-align:right"><span>${this.point.y}</span></td>
              </tr>
            </table>
          `;
        },
      },
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    barChart() {
      return {
        dados: [
          {
            name: 'Resposta A',
            data: this.relatorio.preferencias.map((p) => ({
              name: `${p.itemA.letra.toUpperCase()}) ${p.itemA.descricao}`,
              y: p.itemA.quantidade,
            })),
            color: '#2D5269',
          },
          {
            name: 'Resposta B',
            data: this.relatorio.preferencias.map((p) => ({
              name: `${p.itemB.letra.toUpperCase()}) ${p.itemB.descricao}`,
              y: p.itemB.quantidade,
            })),
            color: '#348ECA',
          },
        ],
        categorias: this.relatorio.preferencias.map((p) => `${p.ordem}. ${p.nome}`),
      };
    },
  },

  methods: {
    async getRelatorio() {
      this.isGetSvg = true;
      await preparePdf(async () => {
        const documento = {
          nome: 'relatorio-geral-preferencia-perfil',
          cabecalho: {
            titulo: 'Relatório Geral das Preferências de Trabalho',
            itens: [
              this.isGeral ? `Unidade(s): ${this.relatorio.unidades.map((u) => u.sigla).join(', ')}`
                : `Unidade: ${this.relatorio.nome} (${this.relatorio.sigla})`,
            ],
          },
          blocos: [
            {
              titulo: 'GRÁFICOS',
              subtitulo: 'PREFERÊNCIAS DE TRABALHO',
              itens: [{ tipo: 'imagem', valor: await convertSvg(this.svg), largura: 160 }],
            },
            {
              titulo: 'RESULTADOS',
              subtitulo: 'PREFERÊNCIAS DE TRABALHO',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'PREFERÊNCIA',
                    'RESPOSTA A',
                    'RESPOSTA B',
                  ],
                  linhas: this.relatorio.preferencias.map((p) => ([
                    `${p.ordem}. ${p.nome}`,
                    p.itemA.quantidade,
                    p.itemB.quantidade,
                  ])),
                },
              }],
            },
          ],
        };
        generatePDF(documento);
      });
      this.isGetSvg = false;
    },
  },
};
</script>
